import { DeleteOutline } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAffiliates, deleteAffiliate } from "../../redux/apiCalls";
import Table from "../../components/advancedTable";
import PageHeader from "../../components/pageHeader/PageHeader";

export default function AffiliateList() {
    const dispatch = useDispatch();
    const affiliates = useSelector((state) =>
        state.affiliate ? state.affiliate.affiliate : undefined
    );
    const currentUser = useSelector((state) => state.user.currentUser);
    const [isLoaded, setIsLoaded] = useState(false);

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );

    const filterCategory = useState(() => {
        if (superadmin) return undefined;
        if (principle) return currentUser._id;
        return currentUser._id;
    })[0];

    const handleDelete = (id) => {
        deleteAffiliate(id, dispatch);
    };

    useEffect(() => {
        const fetchData = async () => {
            const res = await getAffiliates(dispatch, filterCategory);
            if (res) {
                setIsLoaded(true);
            }
        };
        fetchData();
    }, [dispatch, filterCategory]);

    const columns = [
        {
            accessor: "code",
            Header: "Promo Code",
            width: 200,
            sortable: false,
        },
        {
            accessor: "userId",
            Header: "User",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">
                    {value ? `${value.name}` : ""}
                </div>
            ),
        },
        {
            accessor: "status",
            Header: "Status",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "action",
            Header: "Action",
            width: 200,
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex justify-center">
                        <DeleteOutline
                            className="productListDelete cursor-pointer text-red-500 hover:text-red-700"
                            onClick={() => handleDelete(params.row.original._id)}
                        />
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className="productList">
                <PageHeader 
                    title="Affiliate Management" 
                    description="Manage affiliate promo codes and their status" 
                />
                {isLoaded === true && (
                    <Table
                        data={affiliates}
                        columns={columns}
                        pageCount={1}
                        totalCount={1}
                        updatePagination={() => {}}
                        paginationState={{ page: 1, limit: 20 }}
                        updateLoaded={setIsLoaded}
                        hidePagination={true}
                    />
                )}
            </div>
        </>
    );
}
